import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateLookbookOrderFulfillment({ payload: { id, orderId, fulfillmentId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.lookbooks.orders.fulfillments.update,
      pathParams: { id, orderId, fulfillmentId },
      data: values
    });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookOrderFulfillmentDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookOrderFulfillmentFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.fulfillments.update.url
    });
  }
}

export const updateLookbookOrderFulfillmentSaga = takeEvery(types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST, updateLookbookOrderFulfillment);
